import { useLocation } from 'react-router-dom'
import workWechatConfig from 'utils/work-wechat-config'
import qs from 'query-string'

function createOauth2URL(back_url) {
  // 提取sessionStorage里面search，以便于从哪里来回哪里去
  const search = window.sessionStorage.getItem('search')
  const oauth2URL =
    'https://open.weixin.qq.com/connect/oauth2/authorize?{params}#wechat_redirect'

  const state = qs.stringify({
    back_url: encodeURIComponent(back_url),
    type: 'redirect',
  })
  const query = `appid=${
    workWechatConfig.appid
  }&redirect_uri=${encodeURIComponent(
    workWechatConfig.redirect_uri + search
  )}&response_type=code&scope=snsapi_base&state=${encodeURIComponent(state)}`

  return oauth2URL.replace('{params}', query)
}

// 企业微信内部授权的登录
const WorkWeChatOauth2 = () => {
  const { search } = useLocation()
  const { back_url } = qs.parse(search)
  const oauth2URL = createOauth2URL(back_url)
  window.location.href = oauth2URL
  return null
}

export default WorkWeChatOauth2
